// import React from "react";
// import Helpers from "../helpers/shared.helper";
import FirebaseAnalytics from "./firebaseAnalytics";
import Flow from "./flow.service";
import Storage from "./storage.service";
// import Translations from "./translation.service";
import User from "./user.service";

var Errors = {};

Errors.handleHTTPError = (error = "error") => {

  let code = Errors.getErrorCode(error);
  let type = Errors.getErrorType(code);

  if (type === "call_login") {
    // console.log("it's a credentials error.. yayyy");
    if (!isNaN(code)) {
      Storage.set("error", code);
    } else {
      Storage.set("error", type);
    }
  }
};

Errors.handleError = (error = "error") => {
  let code = Errors.getErrorCode(error);
  let screen = Storage.get('Page_name');
  let firebase_param = {
    error_title: error?.response?.config?.url ? error?.response?.config?.url : screen,
    error_message: error?.response?.data?.error ? error?.response?.data?.error : screen,
    error_code: error?.response?.data?.code ? error?.response?.data?.code : screen,
    screen_name: screen,
    backend_error: error?.response?.status ? error?.response?.status : screen,
  }
  FirebaseAnalytics.error_ocurred(firebase_param);

  // let message = "error_" + code;
  // message = message.replace("-", "");

  // console.log(message);

  let type = Errors.getErrorType(code);
  if (Storage.get("paymentFailedError", true)) {
    Storage.clear("paymentFailedError");
    Storage.clear("error", null);
    Storage.set("paymentErrorCode", code);
    Storage.set("paymentErrormsg", error?.response?.data?.error,);

    return;
  }

  if (Storage.get("imsiCodeError", true)) {
    Storage.clear("imsiCodeError");
    Storage.clear("error", null);
    Storage.set("imsiCodeError", code);
    return;
  }
  if (Storage.get("reportErrorStatus", true)) {
    Storage.clear("reportErrorStatus");
    Storage.set("error", null);
    return;
  }

  if (Storage.get("reportOtpError", true)) {
    Storage.clear("reportOtpError");
    Storage.set("error", null);
    return;
  }

  if (Storage.get("topupNumberError", true)) {
    Storage.clear("topupNumberError");
    Storage.set("error", null);
    return;
  }

  if (Storage.get("advertisementOtpError", true)) {
    Storage.clear("advertisementOtpError");
    Storage.set("error", null);
    return;
  }

  if (Storage.get("promotionErrorStatus", true)) {
    Storage.set("promotionErrorCode", code);
    Storage.clear("promotionErrorStatus");
    Storage.set("error", null);
    return;
  }

  if (Storage.get("eligibilityErrorStatus", true)) {
    Storage.set("eligibilityErrorCode", code);
    Storage.clear("eligibilityErrorStatus");
    Storage.set("error", null);
    return;
  }
  if (Storage.get("citcErrorStatus", true)) {
    Storage.set("citcErrorCode", code);
    Storage.clear("citcErrorStatus");
    Storage.set("error", null);
    return;
  }

  if (Storage.get("otpErrorStatus", true)) {
    Storage.set("otpErrorCode", code);
    Storage.clear("otpErrorStatus");
    Storage.set("error", null);
    return;
  }
  if (Storage.get("payment_error")) {
    Storage.clear("payment_error");
    Flow.goTo(Flow.get("root_id"));
  }


  if (type === 'general_error') {
    Flow.goTo(Flow.get("root_id"));
  }

  if (type !== "error_wrong_email_or_password") {
    if (!isNaN(code)) {
      Storage.set("error", code);
    } else {
      Storage.set("error", type);
    }
  }

  // if (type === "error") {
  //   // console.log("Error! redirecting to root...: ");
  //   Flow.goTo(Flow.get("root_id"));
  // }
};

Errors.doAction = (key) => {
  // console.log(key);

  let type = Errors.getErrorType(key);
  if (type === "call_login") {
    User.logout();
    // console.log("called logout");

  } else {
    User.fetchFlowStatus(733444423);
  }
  Storage.clear("error");
};

Errors.redirectAfterError = () => {
  // console.log("Error! redirecting to root...: ");
  Flow.goTo(Flow.get("root_id"));
};

Errors.getErrorCode = (error) => {
  if (error.response && error.response.data) {

    if (error.response.data.code || Object.keys(error.response.data).indexOf('code') !== -1) {
      return error.response.data.code;
    }

  } else {
    if (typeof error === "string" && isNaN(parseInt(error, 10))) {
      return error;
    }
  }
  return "error";
};

Errors.getErrorType = (code) => {
  let type = "general_error";

  if (typeof code === "string" && isNaN(parseInt(code, 10))) {
    type = code;
  } else {
    switch (code) {
      case -7011:
        type = "error_insufficient_funds";
        break;
      case 2:
        type = "error_user_registered";
        break;
      case -199:
        type = "error_email_not_found";
        break;
      case -200:
        type = "error_invalid_email";
        break;

      case -401:
        type = "error_unsupported_delivery_location";
        break;

      case -114:
        type = "error_no_delivery_location";
        break;

      case -7103:
      case -10012:
        type = "error_payment_declined";
        break;
      case -7122:
        type = "error_activation_sim_is_activated";
        break;
      case -7120:
        type = "error_activation_sim_not_associated";
        break;

      case -2015:
        type = "error_number_reserved";
        break;

      case -2010:
      case -5003:
        type = "error_number_expired";
        break;

      case -7104:
      case -7043:
      case -27:
        type = "call_login";
        break;

      case -435:
        type = "terminated_account";
        break;

      case -107:
        type = "error_wrong_email_or_password";
        break;

      case -7076:
        type = "error_MNP_verification_code_expired";
        break;
      case -23:
        type = "error_MNP_MSISDN_already_registered";
        break;
      case -8002:
        type = "error_MNP_invalid_MSISDN";
        break;

      case -10001:
      case -10013:
      case -10015:
      case -7100:
      case -7059:
      case -7101:
        type = "error_payment";
        break;

      case -444:
        type = "user_already_paid_for_a_plan";
        break;

      default:
        type = "general_error";
        break;
    }
  }

  return type;
};

export default Errors;
